
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var MAX_MENU_HEIGHT = 300;
var PLACEHOLDER = "Select...";
var MIN_WIDTH = "5rem";
var MAX_WIDTH = "25rem";

export { MAX_MENU_HEIGHT, MAX_WIDTH, MIN_WIDTH, PLACEHOLDER };
//# sourceMappingURL=constants.js.map
